/* istanbul ignore file */
import React from 'react';
import { TimelineLayout, Timeline, TimelinePageLayout } from 'framework/ui/timeline';
import useEmployeeFeedbacksService from 'domain/people/employee/feedbacks/EmployeeFeedbacksService';
import useFeedbackAboutMeRegistry from 'domain/people/employee/feedbacks/FeedbackAboutMeRegistry';

const EmployeeFeedbacksList = () => {
  const { search } = useEmployeeFeedbacksService();
  const feedbackRegistry = useFeedbackAboutMeRegistry();

  return (
    <Timeline registries={[feedbackRegistry] as any} getDataMethod={request => search(request)}>
      <TimelinePageLayout title="Feedback about my work" hasAddForm={false}>
        <TimelineLayout noEntriesMessage="No feedback about my work yet." />
      </TimelinePageLayout>
    </Timeline>
  );
};

export default EmployeeFeedbacksList;
